// 物流信息弹窗功能
(function() {
  /**
   * 关闭所有活跃弹窗的公共方法
   */
  function closeAllActiveModals() {
    var activeModals = document.querySelectorAll('.shipping-info-modal.active');
    activeModals.forEach(function(modal) {
      modal.classList.remove('active');
    });
    document.body.style.overflow = '';
  }

  // 事件委托：点击物流项 → 打开对应弹窗（对动态DOM同样生效）
  document.addEventListener('click', function(e) {
    // 向上查找最近的 .shipping-block-item[data-shipping-type]（兼容点击子元素的情况）
    var item = e.target.closest('.shipping-block-item[data-shipping-type]');
    if (!item) return;

    e.preventDefault();
    e.stopPropagation();

    var shippingType = item.getAttribute('data-shipping-type');
    // 在同一 .product-block 中查找对应类型的弹窗
    var parentBlock = item.closest('.product-block');
    if (!parentBlock) return;

    var modal = parentBlock.querySelector('.shipping-info-modal[data-modal-type="' + shippingType + '"]');
    if (!modal) {
      console.warn('未找到对应的弹窗元素: ' + shippingType);
      return;
    }

    // 先关闭该 product-block 内所有弹窗，再打开目标弹窗
    var allModals = parentBlock.querySelectorAll('.shipping-info-modal');
    allModals.forEach(function(m) {
      m.classList.remove('active');
    });
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // 事件委托：点击关闭按钮 → 关闭弹窗（对动态DOM同样生效）
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.shipping-info-modal-close');
    if (!closeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var modal = closeBtn.closest('.shipping-info-modal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  // 事件委托：点击弹窗背景（遮罩层）→ 关闭弹窗（对动态DOM同样生效）
  document.addEventListener('click', function(e) {
    // 仅当直接点击的是 .shipping-info-modal 本身（即背景遮罩区域）时才关闭
    if (e.target.classList && e.target.classList.contains('shipping-info-modal') && e.target.classList.contains('active')) {
      e.target.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  // ESC键关闭弹窗
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllActiveModals();
    }
  });
})();